import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const TRANSLATIONS = {
  English: {
    Dashboard: "Dashboard",
    Jobs: "Jobs",
    Applicants: "Applicants",
    ReferenceRequest: "Reference Request",
    ReferenceQuestion: "Reference Question",
    AgencyPartner: "Agency Partner",
    Reports: "Reports",
    TrashBin: "Trash Bin",
    FollowUsOn: "Follow Us On",
  },
  Japanese: {
    Dashboard: "ダッシュボード",
    Jobs: "求人",
    Applicants: "応募者",
    ReferenceRequest: "リファレンス依頼",
    ReferenceQuestion: "リファレンス質問",
    AgencyPartner: "エージェンシーパートナー",
    Reports: "レポート",
    TrashBin: "ゴミ箱",
    FollowUsOn: "フォローしてください",
  },
};

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    sessionStorage.getItem("preferred-language") || "English"
  );

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLanguage(
        sessionStorage.getItem("preferred-language") || "English"
      );
    };

    // Listen for storage changes
    window.addEventListener("storage", handleLanguageChange);

    return () => {
      window.removeEventListener("storage", handleLanguageChange);
    };
  }, []);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };
  return (
    <>
      <button
        className={`mobile-menu-btn ${showSidebar ? "show" : ""}`}
        onClick={toggleSidebar}
      >
        {showSidebar ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay */}
      <div
        className={`sidebar-overlay ${showSidebar ? "show" : ""}`}
        onClick={closeSidebar}
      />
      <div
        className={`MockMain-sidebar d-flex flex-column gap-4 ${
          showSidebar ? "show" : ""
        }`}
      >
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-dashboard"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.281738 18.9484V6.94836L8.28174 0.948364L16.2817 6.94836V18.9484H10.2817V11.9484H6.28174V18.9484H0.281738Z" />
          </svg>
          {TRANSLATIONS[currentLanguage].Dashboard}{" "}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-jobs"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 0C8.20435 0 7.44129 0.316071 6.87868 0.87868C6.31607 1.44129 6 2.20435 6 3V4H3C2.20435 4 1.44129 4.31607 0.87868 4.87868C0.316071 5.44129 0 6.20435 0 7V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H17C17.7956 18 18.5587 17.6839 19.1213 17.1213C19.6839 16.5587 20 15.7956 20 15V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4H14V3C14 2.20435 13.6839 1.44129 13.1213 0.87868C12.5587 0.316071 11.7956 0 11 0H9ZM12 4H8V3C8 2.73478 8.10536 2.48043 8.29289 2.29289C8.48043 2.10536 8.73478 2 9 2H11C11.2652 2 11.5196 2.10536 11.7071 2.29289C11.8946 2.48043 12 2.73478 12 3V4Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].Jobs}{" "}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-applicants"
        >
          <svg
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6666 6.99999C11.8527 6.99999 11.0658 6.63488 10.4499 5.97227C9.85101 5.32596 9.48526 4.46409 9.42074 3.54613C9.35186 2.56693 9.64913 1.66648 10.2575 1.01023C10.8659 0.353977 11.7166 0 12.6666 0C13.6098 0 14.4628 0.36034 15.0693 1.015C15.6816 1.67602 15.9797 2.57488 15.9108 3.54573C15.8447 4.46488 15.4793 5.32636 14.8816 5.97187C14.2673 6.63488 13.4808 6.99999 12.6666 6.99999ZM17.8848 14H7.44871C7.28092 14.0009 7.11516 13.9631 6.96419 13.8895C6.81322 13.816 6.68106 13.7086 6.57788 13.5756C6.46843 13.4315 6.39285 13.2643 6.35679 13.0867C6.32074 12.9091 6.32514 12.7256 6.36967 12.5499C6.70296 11.2052 7.52867 10.0899 8.75733 9.3251C9.84784 8.64658 11.236 8.27272 12.6666 8.27272C14.1252 8.27272 15.477 8.63067 16.5738 9.3088C17.8052 10.0696 18.6321 11.1912 18.9638 12.5523C19.0078 12.7281 19.0117 12.9116 18.9753 13.0891C18.9388 13.2667 18.8629 13.4336 18.7533 13.5776C18.6502 13.7099 18.5183 13.8168 18.3678 13.89C18.2173 13.9632 18.052 14.0008 17.8848 14ZM5.18534 7.15908C3.79241 7.15908 2.56771 5.85772 2.45411 4.25846C2.3979 3.43914 2.65202 2.68147 3.1666 2.12585C3.67564 1.57579 4.39368 1.27273 5.18534 1.27273C5.97701 1.27273 6.6895 1.57738 7.20131 2.13062C7.71985 2.69062 7.97318 3.4467 7.91381 4.25926C7.8002 5.85812 6.5759 7.15908 5.18534 7.15908ZM7.78437 8.40993C7.0881 8.06789 6.18442 7.89687 5.18574 7.89687C4.01962 7.89687 2.88715 8.20232 1.99653 8.75675C0.986762 9.38635 0.307516 10.3031 0.0332048 11.41C-0.00693837 11.5692 -0.0107352 11.7355 0.0220983 11.8964C0.0549319 12.0572 0.123546 12.2086 0.222808 12.3391C0.316995 12.4606 0.437659 12.5587 0.57552 12.626C0.713381 12.6933 0.864766 12.728 1.01803 12.7273H5.41176C5.48592 12.7272 5.55772 12.7011 5.61465 12.6533C5.67158 12.6056 5.71002 12.5393 5.72328 12.466C5.72763 12.4409 5.73317 12.4158 5.73951 12.3912C6.07517 11.0365 6.86169 9.89186 8.02385 9.05743C8.06659 9.02647 8.10097 8.98529 8.12387 8.9376C8.14678 8.88992 8.15747 8.83725 8.155 8.78436C8.15252 8.73148 8.13695 8.68005 8.10969 8.63474C8.08244 8.58943 8.04436 8.55167 7.99891 8.52488C7.93677 8.48829 7.86552 8.44971 7.78437 8.40993Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].Applicants}{" "}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-request"
        >
          <svg
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H22C22.55 0 23.021 0.196 23.413 0.588C23.805 0.98 24.0007 1.45067 24 2V16C24 16.55 23.8043 17.021 23.413 17.413C23.0217 17.805 22.5507 18.0007 22 18H2ZM9 11C9.83333 11 10.5417 10.7083 11.125 10.125C11.7083 9.54167 12 8.83333 12 8C12 7.16667 11.7083 6.45833 11.125 5.875C10.5417 5.29167 9.83333 5 9 5C8.16667 5 7.45833 5.29167 6.875 5.875C6.29167 6.45833 6 7.16667 6 8C6 8.83333 6.29167 9.54167 6.875 10.125C7.45833 10.7083 8.16667 11 9 11ZM2.1 16H15.9C15.2 14.75 14.2333 13.771 13 13.063C11.7667 12.355 10.4333 12.0007 9 12C7.56667 11.9993 6.23333 12.3537 5 13.063C3.76667 13.7723 2.8 14.7513 2.1 16ZM15 8H20C20.2833 8 20.521 7.904 20.713 7.712C20.905 7.52 21.0007 7.28267 21 7V4C21 3.71667 20.904 3.47933 20.712 3.288C20.52 3.09667 20.2827 3.00067 20 3H15C14.7167 3 14.4793 3.096 14.288 3.288C14.0967 3.48 14.0007 3.71733 14 4V7C14 7.28333 14.096 7.521 14.288 7.713C14.48 7.905 14.7173 8.00067 15 8ZM17.5 5.75L19.35 4.45C19.4833 4.35 19.625 4.33733 19.775 4.412C19.925 4.48667 20 4.60767 20 4.775C20 4.79167 19.9417 4.90833 19.825 5.125L18.075 6.35C17.8917 6.48333 17.7 6.55 17.5 6.55C17.3 6.55 17.1083 6.48333 16.925 6.35L15.175 5.125C15.1583 5.10833 15.1 4.99167 15 4.775C15 4.60833 15.075 4.48733 15.225 4.412C15.375 4.33667 15.5167 4.34933 15.65 4.45L17.5 5.75Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].ReferenceRequest}{" "}
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-questions"
        >
          <svg
            width="11"
            height="13"
            viewBox="0 0 11 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.625V11.375C0 11.806 0.175595 12.2193 0.488155 12.524C0.800716 12.8288 1.22464 13 1.66667 13H10.5C10.6326 13 10.7598 12.9486 10.8536 12.8572C10.9473 12.7658 11 12.6418 11 12.5125C11 12.3832 10.9473 12.2592 10.8536 12.1678C10.7598 12.0764 10.6326 12.025 10.5 12.025H1.66667C1.48986 12.025 1.32029 11.9565 1.19526 11.8346C1.07024 11.7127 1 11.5474 1 11.375H10.5C10.6326 11.375 10.7598 11.3236 10.8536 11.2322C10.9473 11.1408 11 11.0168 11 10.8875V1.625C11 1.4116 10.9569 1.20029 10.8731 1.00314C10.7894 0.805985 10.6666 0.626847 10.5118 0.475951C10.3571 0.325056 10.1733 0.20536 9.97114 0.123696C9.76893 0.0420319 9.5522 0 9.33333 0H1.66667C1.22464 0 0.800716 0.171205 0.488155 0.475951C0.175595 0.780698 0 1.19402 0 1.625ZM4.66667 3.9117C4.66353 4.03895 4.60947 4.15997 4.51604 4.24888C4.42261 4.33778 4.29722 4.38754 4.16667 4.3875C3.66667 4.3875 3.66667 3.89935 3.66667 3.89935V3.8935C3.66644 3.86438 3.66822 3.83528 3.672 3.8064C3.70081 3.55515 3.79743 3.31584 3.952 3.11285C4.25467 2.7144 4.79867 2.42255 5.67533 2.4375C6.30867 2.44855 6.87067 2.70725 7.22267 3.133C7.58067 3.56655 7.70133 4.1535 7.464 4.73135C7.22267 5.3196 6.67667 5.5536 6.36267 5.6875L6.32933 5.70245C6.14267 5.7824 6.054 5.824 6.00067 5.8656L6 5.86625V6.33685C6.00009 6.46614 5.94749 6.59017 5.85379 6.68166C5.76008 6.77314 5.63294 6.82459 5.50033 6.82467C5.36773 6.82476 5.24051 6.77348 5.14668 6.68212C5.05285 6.59076 5.00009 6.46679 5 6.3375V5.85C5 5.51005 5.168 5.26695 5.37533 5.10445C5.542 4.97445 5.752 4.88475 5.89933 4.82105L5.92467 4.81C6.286 4.65465 6.458 4.55845 6.536 4.36865C6.58179 4.26661 6.59744 4.15412 6.58118 4.04387C6.56493 3.93362 6.51742 3.82999 6.444 3.74465C6.296 3.5659 6.02467 3.41835 5.658 3.4125C5.03467 3.4021 4.828 3.59775 4.756 3.6933C4.70775 3.75609 4.67698 3.82999 4.66667 3.9078V3.9117ZM6.16667 8.125C6.16667 8.29739 6.09643 8.46272 5.9714 8.58462C5.84638 8.70652 5.67681 8.775 5.5 8.775C5.32319 8.775 5.15362 8.70652 5.0286 8.58462C4.90357 8.46272 4.83333 8.29739 4.83333 8.125C4.83333 7.95261 4.90357 7.78728 5.0286 7.66538C5.15362 7.54348 5.32319 7.475 5.5 7.475C5.67681 7.475 5.84638 7.54348 5.9714 7.66538C6.09643 7.78728 6.16667 7.95261 6.16667 8.125Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].ReferenceQuestion}{" "}
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-agency-partners"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.291 5.99997H20.001C20.2662 5.99997 20.5206 6.10532 20.7081 6.29286C20.8956 6.4804 21.001 6.73475 21.001 6.99997V14C21.001 14.2652 20.8956 14.5195 20.7081 14.7071C20.5206 14.8946 20.2662 15 20.001 15H18.001L13.831 9.16397C13.5885 8.82461 13.2459 8.56957 12.8512 8.43455C12.4566 8.29953 12.0296 8.29129 11.63 8.41097L9.144 9.15697C8.79817 9.26049 8.43078 9.26849 8.08078 9.18011C7.73077 9.09173 7.41122 8.91026 7.156 8.65497L6.863 8.36197C6.75839 8.25738 6.67829 8.13088 6.62846 7.9916C6.57864 7.85232 6.56034 7.70371 6.57488 7.5565C6.58942 7.4093 6.63644 7.26714 6.71254 7.1403C6.78865 7.01345 6.89195 6.90507 7.015 6.82297L12.416 3.22297C12.7384 3.00788 13.1164 2.8911 13.5039 2.88684C13.8915 2.88258 14.2719 2.99102 14.599 3.19897L18.755 5.84397C18.9149 5.94561 19.1015 5.99971 19.291 5.99997ZM5.027 14.295L3.411 15.709C3.30055 15.8058 3.21279 15.9257 3.15395 16.0603C3.09511 16.1949 3.06663 16.3408 3.07055 16.4876C3.07446 16.6344 3.11067 16.7786 3.1766 16.9098C3.24252 17.0411 3.33655 17.1562 3.452 17.247L8.592 21.287C8.70499 21.3759 8.83584 21.4394 8.97562 21.4732C9.11539 21.507 9.26081 21.5102 9.40195 21.4827C9.5431 21.4552 9.67664 21.3976 9.79348 21.3137C9.91032 21.2299 10.0077 21.1219 10.079 20.997L10.783 19.765C10.9926 19.3981 11.0807 18.9742 11.0345 18.5542C10.9883 18.1342 10.8103 17.7396 10.526 17.427L7.824 14.455C7.47164 14.0673 6.98123 13.8333 6.4582 13.8034C5.93516 13.7735 5.42127 13.95 5.027 14.295ZM7.046 4.99997H3C2.73478 4.99997 2.48043 5.10532 2.29289 5.29286C2.10536 5.4804 2 5.73475 2 5.99997V13.516C2.00005 13.9193 2.12206 14.3132 2.35 14.646L2.424 14.58L4.039 13.166C4.72899 12.5622 5.62835 12.2533 6.54372 12.3056C7.45909 12.358 8.31736 12.7674 8.934 13.446L11.636 16.418C12.1333 16.9648 12.4447 17.6551 12.5255 18.3899C12.6063 19.1246 12.4525 19.8661 12.086 20.508L11.431 21.654C11.7136 21.7611 12.0168 21.8028 12.3178 21.776C12.6188 21.7492 12.9098 21.6544 13.169 21.499L17.579 18.853C17.6972 18.7819 17.7995 18.6872 17.8794 18.5747C17.9592 18.4622 18.0149 18.3344 18.043 18.1994C18.0711 18.0643 18.0709 17.9249 18.0425 17.7899C18.0141 17.6549 17.9581 17.5273 17.878 17.415L12.611 10.036C12.5503 9.95122 12.4647 9.88755 12.3661 9.85384C12.2675 9.82013 12.1608 9.81808 12.061 9.84797L9.575 10.593C8.9698 10.7745 8.32673 10.7889 7.71404 10.6344C7.10135 10.48 6.54188 10.1627 6.095 9.71597L5.802 9.42297C5.54038 9.16149 5.34005 8.84522 5.21544 8.49696C5.09083 8.1487 5.04505 7.77713 5.0814 7.40904C5.11775 7.04095 5.23532 6.68551 5.42564 6.36835C5.61597 6.0512 5.87429 5.78022 6.182 5.57497L7.046 4.99997Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].AgencyPartner}{" "}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-reports"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 0H15C13.8954 0 13 0.89543 13 2V16C13 17.1046 13.8954 18 15 18H16C17.1046 18 18 17.1046 18 16V2C18 0.89543 17.1046 0 16 0Z"
              fill="#686868"
            />
            <path
              d="M9.5 6H8.5C7.39543 6 6.5 6.89543 6.5 8V16C6.5 17.1046 7.39543 18 8.5 18H9.5C10.6046 18 11.5 17.1046 11.5 16V8C11.5 6.89543 10.6046 6 9.5 6Z"
              fill="#686868"
            />
            <path
              d="M3 13H2C0.89543 13 0 13.8954 0 15V16C0 17.1046 0.89543 18 2 18H3C4.10457 18 5 17.1046 5 16V15C5 13.8954 4.10457 13 3 13Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].Reports}{" "}
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/ai-reference-archives"
        >
          <svg
            width="2"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.0026 10.6667C1.0026 11.4 1.6026 12 2.33594 12H7.66927C8.4026 12 9.0026 11.4 9.0026 10.6667V2.66667H1.0026V10.6667ZM9.66927 0.666667H7.33594L6.66927 0H3.33594L2.66927 0.666667H0.335938V2H9.66927V0.666667Z"
              fill="#686868"
            />
          </svg>
          {TRANSLATIONS[currentLanguage].TrashBin}{" "}
        </NavLink>

        {/* Follow Us Section */}
        {/* <div className="follow-us p-3">
          <p className="mb-3"> {TRANSLATIONS[currentLanguage].FollowUsOn} </p>
          <div className="social-icons d-flex align-item-center justify-content-around gap-1">
            <a
              href="https://www.linkedin.com/company/hr-hatch/?viewAsMember=true&fbclid=IwZXh0bgNhZW0CMTEAAR04-4YiMGiy8P8WBncX6i1SV_ojpFaXku3y8a6sW17Cnxag9zYkgTPrmPU_aem_17xurdIqUzSoNuVh-ZcU4w"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.053 0H4.447C3.26758 0 2.13647 0.468522 1.3025 1.3025C0.468522 2.13647 0 3.26758 0 4.447V15.053C0 16.2324 0.468522 17.3635 1.3025 18.1975C2.13647 19.0315 3.26758 19.5 4.447 19.5H15.053C16.2324 19.5 17.3635 19.0315 18.1975 18.1975C19.0315 17.3635 19.5 16.2324 19.5 15.053V4.447C19.5 3.26758 19.0315 2.13647 18.1975 1.3025C17.3635 0.468522 16.2324 0 15.053 0ZM6.593 15.742C6.59614 15.7964 6.58811 15.8509 6.56942 15.9021C6.55072 15.9534 6.52176 16.0002 6.4843 16.0398C6.44684 16.0794 6.40167 16.111 6.35158 16.1325C6.30149 16.154 6.24752 16.1651 6.193 16.165H4.413C4.30566 16.1624 4.20362 16.1178 4.12883 16.0407C4.05403 15.9637 4.01244 15.8604 4.013 15.753V8.35C4.01153 8.29655 4.02079 8.24335 4.04023 8.19355C4.05967 8.14374 4.0889 8.09834 4.1262 8.06002C4.16349 8.0217 4.20808 7.99125 4.25734 7.97047C4.3066 7.94968 4.35953 7.93898 4.413 7.939H6.193C6.24647 7.93898 6.2994 7.94968 6.34866 7.97047C6.39792 7.99125 6.44251 8.0217 6.4798 8.06002C6.5171 8.09834 6.54633 8.14374 6.56577 8.19355C6.58521 8.24335 6.59447 8.29655 6.593 8.35V15.742ZM5.27 6.382C5.07729 6.38056 4.88674 6.34117 4.70925 6.26608C4.53176 6.191 4.37079 6.08169 4.23554 5.9444C4.10029 5.80711 3.99341 5.64452 3.921 5.46593C3.84858 5.28733 3.81206 5.09621 3.8135 4.9035C3.81494 4.71079 3.85433 4.52024 3.92942 4.34275C4.0045 4.16526 4.11381 4.00429 4.2511 3.86904C4.38839 3.73379 4.55098 3.62691 4.72957 3.5545C4.90817 3.48208 5.09929 3.44556 5.292 3.447C5.67452 3.45944 6.03703 3.62087 6.30219 3.89686C6.56734 4.17284 6.71415 4.54152 6.71128 4.92423C6.7084 5.30694 6.55609 5.67337 6.28682 5.94535C6.01755 6.21732 5.65266 6.3733 5.27 6.38M16.087 15.73C16.0865 15.831 16.0469 15.928 15.9764 16.0003C15.9058 16.0727 15.81 16.1149 15.709 16.118H13.83C13.7288 16.1149 13.6328 16.0726 13.5623 16C13.4918 15.9274 13.4522 15.8302 13.452 15.729V12.305C13.452 11.794 13.608 10.082 12.096 10.082C10.917 10.082 10.684 11.282 10.639 11.816V15.807C10.639 15.9084 10.5996 16.0058 10.529 16.0786C10.4585 16.1514 10.3623 16.1939 10.261 16.197H8.438C8.33474 16.1967 8.2358 16.1555 8.16287 16.0824C8.08995 16.0093 8.049 15.9103 8.049 15.807V8.314C8.05212 8.21266 8.09458 8.11652 8.16739 8.04595C8.24019 7.97539 8.33761 7.93595 8.439 7.936H10.261C10.3624 7.93595 10.4598 7.97539 10.5326 8.04595C10.6054 8.11652 10.6479 8.21266 10.651 8.314V8.959C10.917 8.56962 11.2843 8.26027 11.7133 8.0643C12.1422 7.86834 12.6165 7.7932 13.085 7.847C16.12 7.847 16.109 10.682 16.109 12.294L16.087 15.73Z" />
              </svg>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2.78571 0C1.24922 0 0 1.24922 0 2.78571V16.7143C0 18.2508 1.24922 19.5 2.78571 19.5H16.7143C18.2508 19.5 19.5 18.2508 19.5 16.7143V2.78571C19.5 1.24922 18.2508 0 16.7143 0H2.78571ZM15.7175 3.65625L11.1994 8.81853L16.5141 15.8438H12.3529L9.0971 11.5825L5.36685 15.8438H3.29933L8.1308 10.3202L3.03382 3.65625H7.29944L10.2462 7.5519L13.65 3.65625H15.7175ZM14.0722 14.6076L6.67701 4.82712H5.4452L12.9231 14.6076H14.0679H14.0722Z" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19.5 9.77444C19.5 4.37895 15.132 0 9.75 0C4.368 0 0 4.37895 0 9.77444C0 14.5053 3.354 18.4444 7.8 19.3534V12.7068H5.85V9.77444H7.8V7.33083C7.8 5.44436 9.33075 3.90977 11.2125 3.90977H13.65V6.8421H11.7C11.1638 6.8421 10.725 7.28195 10.725 7.81955V9.77444H13.65V12.7068H10.725V19.5C15.6488 19.0113 19.5 14.8474 19.5 9.77444Z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.396 16.1644L16.3841 16.1666L16.3072 16.2045L16.2855 16.2088L16.2704 16.2045L16.1934 16.1666C16.1819 16.163 16.1732 16.1648 16.1674 16.172L16.1631 16.1828L16.1447 16.6465L16.1501 16.6682L16.1609 16.6822L16.2736 16.7624L16.2899 16.7667L16.3029 16.7624L16.4155 16.6822L16.4285 16.6649L16.4329 16.6465L16.4144 16.1839C16.4115 16.1723 16.4054 16.1658 16.396 16.1644ZM16.6831 16.042L16.669 16.0442L16.4686 16.1449L16.4578 16.1557L16.4545 16.1677L16.474 16.6335L16.4794 16.6465L16.4881 16.6541L16.7059 16.7548C16.7196 16.7584 16.73 16.7555 16.7373 16.7462L16.7416 16.731L16.7048 16.0658C16.7012 16.0528 16.6939 16.0449 16.6831 16.042ZM15.9085 16.0442C15.9037 16.0413 15.898 16.0403 15.8926 16.0415C15.8871 16.0427 15.8824 16.046 15.8793 16.0507L15.8728 16.0658L15.8359 16.731C15.8367 16.744 15.8428 16.7527 15.8544 16.757L15.8706 16.7548L16.0884 16.6541L16.0992 16.6454L16.1035 16.6335L16.1219 16.1677L16.1187 16.1547L16.1079 16.1438L15.9085 16.0442Z"
                  fill="#686868"
                />
                <path
                  d="M14.0833 0C15.5199 0 16.8977 0.570683 17.9135 1.5865C18.9293 2.60233 19.5 3.98008 19.5 5.41667V14.0833C19.5 15.5199 18.9293 16.8977 17.9135 17.9135C16.8977 18.9293 15.5199 19.5 14.0833 19.5H5.41667C3.98008 19.5 2.60233 18.9293 1.5865 17.9135C0.570683 16.8977 0 15.5199 0 14.0833V5.41667C0 3.98008 0.570683 2.60233 1.5865 1.5865C2.60233 0.570683 3.98008 0 5.41667 0H14.0833ZM9.75 5.41667C8.60073 5.41667 7.49853 5.87321 6.68587 6.68587C5.87321 7.49853 5.41667 8.60073 5.41667 9.75C5.41667 10.8993 5.87321 12.0015 6.68587 12.8141C7.49853 13.6268 8.60073 14.0833 9.75 14.0833C10.8993 14.0833 12.0015 13.6268 12.8141 12.8141C13.6268 12.0015 14.0833 10.8993 14.0833 9.75C14.0833 8.60073 13.6268 7.49853 12.8141 6.68587C12.0015 5.87321 10.8993 5.41667 9.75 5.41667ZM9.75 7.58333C10.3246 7.58333 10.8757 7.81161 11.2821 8.21794C11.6884 8.62426 11.9167 9.17536 11.9167 9.75C11.9167 10.3246 11.6884 10.8757 11.2821 11.2821C10.8757 11.6884 10.3246 11.9167 9.75 11.9167C9.17536 11.9167 8.62426 11.6884 8.21794 11.2821C7.81161 10.8757 7.58333 10.3246 7.58333 9.75C7.58333 9.17536 7.81161 8.62426 8.21794 8.21794C8.62426 7.81161 9.17536 7.58333 9.75 7.58333ZM14.625 3.79167C14.3377 3.79167 14.0621 3.9058 13.859 4.10897C13.6558 4.31213 13.5417 4.58768 13.5417 4.875C13.5417 5.16232 13.6558 5.43787 13.859 5.64103C14.0621 5.8442 14.3377 5.95833 14.625 5.95833C14.9123 5.95833 15.1879 5.8442 15.391 5.64103C15.5942 5.43787 15.7083 5.16232 15.7083 4.875C15.7083 4.58768 15.5942 4.31213 15.391 4.10897C15.1879 3.9058 14.9123 3.79167 14.625 3.79167Z"
                  // fill="#686868"
                />
              </svg>
            </a>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Sidebar;
